import {
    SharedConsumerMovementFilters,
    SharedConsumerSalesFilters
} from 'src/app/_shared/stores/shared-consumer/shared-consumer-state';

const stateName = '[SubventionConsumerMovement] ';

export class SharedConsumerSetConsumerMovementFiltersAction {
    static readonly type = stateName + ' SetConsumerMovementFilters';

    constructor(public params: {filters?: SharedConsumerMovementFilters, envelopeLabel?: string} = null) {
    }
}

export class SharedConsumerSetConsumerSalesFiltersAction {
    static readonly type = stateName + ' SetConsumerSalesFilters';

    constructor(public filters: SharedConsumerSalesFilters = null) {
    }
}

export class SharedConsumerLoadRelatedListAction {
    static readonly type = stateName + 'LoadRelatedList';
}

export class SubventionConsumerLoadSalesListAction {
    static readonly type = stateName + 'LoadSalesList';
}

export class SubventionConsumerLoadMovementListAction {
    static readonly type = stateName + 'LoadMovementList';
}
